import moment from 'moment';
import parseDms from './parseDms';
import { Option } from '../interfaces';

function _formatDateTime(value) {
  return value == null
    ? ''
    : moment
        .utc(value)
        .local()
        .format('DD-MM-YYYY  HH:mm:ss');
}
export default {
  formatBoolean(value) {
    return value ? 'Ja' : 'Nee';
  },
  formatDate(value) {
    return value == null
      ? ''
      : moment
          .utc(value)
          .local()
          .format('DD-MM-YYYY');
  },
  formatDateTime(value) {
    return _formatDateTime(value);
  },
  formatTimeStamp(value) {
    return _formatDateTime(value);
  },
  formatMoney(value) {
    if (value === null) {
      return '';
    } else {
      return '€' + value;
      // return accounting.formatMoney(value, '€', 2)
    }
  },
  formatDataType(value) {
    // TODO support other data types
    if (value === 'OK/NOK') {
      return 'integer-boolean';
    } else if (value === 'Getal') {
      return 'number';
    } else if (value === 'Keuze') {
      return 'optionlist';
    } else if (value === 'Datum') {
      return 'custom-date';
    } else if (value === 'GPS Positie') {
      return 'gps';
    } else {
      return 'text';
    }
  },
  formatList(list: string[]) {
    if (list) {
      const optionList: Option[] = [];
      for (let i = 0; i < list.length; i++) {
        const option: Option = { value: i, text: list[i] };
        optionList.push(option);
      }
      return optionList;
    }
  },
  formatCoordinates(value) {
    try {
      return parseDms(value);
    } catch (error) {
      return null;
    }
  }
};
